/* eslint-disable react-hooks/exhaustive-deps */
import ICONS from "../../../../../assets/Icons";
import globalText from "../../../../../utils/globalText";
import CommonLayout from "../../../../_utils/CommonLayout";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import SourceDestinationAccountDetail from "../../../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";

const BeneficiaryTransactionStepAccount = ({
  txnPayLoad,
  setIsModalOpen,
  setTxnPayLoad,
  isModalOpen,
  shouldShowAssociatedAccounts,
  handleAccountSelection,
  activeType,
  setActiveType,
  setRemPan,
  setRemAccount,
  setRemIFSC,
  remIFSC,
  remAccount,
  remPan,
  openOwner,
  setOpenOwner,
  handleOwnerSelection,
  isConfidential,
  setIsConfidential,
}) => {
  return (
    <>
      <div className="w-width-full flex flex-col Qlg:px-padding-base px-padding-md gap-gap-md Qsmd:py-padding-md py-padding-md max-w-tab-width-normal mx-auto">
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <SourceDestinationAccountDetail
              type="source"
              modalOpen={openOwner}
              setModalOpen={setOpenOwner}
              txnPayLoad={txnPayLoad}
              setTxnPayLoad={setTxnPayLoad}
              handleOnAccountSelection={handleOwnerSelection}
            />
          </div>

          <div
            className={`w-width-full lg:max-w-[var(--create-box-width)] ${
              !txnPayLoad?.ownerBankAccountNo
                ? "opacity-light-opacity pointer-events-none"
                : "opacity-base-opacity"
            }`}
          >
            <SourceDestinationAccountDetail
              type="destination"
              flow="beneficiary"
              modalOpen={isModalOpen}
              setModalOpen={setIsModalOpen}
              txnPayLoad={txnPayLoad}
              setTxnPayLoad={setTxnPayLoad}
              shouldShowAssociatedAccounts={shouldShowAssociatedAccounts}
              handleOnAccountSelection={handleAccountSelection}
              activeType={activeType}
              setActiveType={setActiveType}
              setRemPan={setRemPan}
              setRemAccount={setRemAccount}
              setRemIFSC={setRemIFSC}
              remIFSC={remIFSC}
              remAccount={remAccount}
              remPan={remPan}
            />
          </div>

          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <ConfidentialCard
              icon={ICONS.CONFIDENTIAL_TRANSACTION}
              title={globalText?.CREATE_AS_CONFIDENTIAL}
              note={globalText?.CONFIDENTIAL_TRANSACTION_NOTE}
              toggleState={isConfidential}
              onToggle={() => setIsConfidential(!isConfidential)}
            />
          </div>
        </CommonLayout>
      </div>
    </>
  );
};

export default BeneficiaryTransactionStepAccount;
